import { ApiBase } from './ApiBase';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataPackage } from '@apis/cas/generated';

@Injectable({ providedIn: 'root' })
export class DataPackageEndpoints extends ApiBase {
  getDataPackage(): Observable<DataPackage> {
    return this.get<DataPackage>(`/game/${this.gameId}/data/${this.dataPackage}`);
  }
  // NEW! Not from CAS Angular repository
  getDataPackageVersion(): Observable<string> {
    return this.get<string>(`/game/${this.gameId}/data/${this.dataPackage}/version`);
  }
}
